// ============================================
// PAGE — Home
// Assembles all sections in order
// ============================================

import Hero       from "../components/Hero";
import Services   from "../components/Services";
import HowItWorks from "../components/HowItWorks";
import Research   from "../components/Research";
import About      from "../components/About";
import Contact    from "../components/Contact";

export default function Home() {
  return (
    <main>
      <Hero />
      <Services />
      <HowItWorks />
      <Research />
      <About />
      <Contact />
    </main>
  );
}
